// extracted by mini-css-extract-plugin
export default {"goBack":"goBack_goBack__fd8F8","icon":"goBack_icon__5oQ7j","mobile":"goBack_mobile__siFR1"};